import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Shield, Mail, Phone, MapPin } from 'lucide-react';
import { COMPANY } from '../config/company';

export default function Footer({ onCTAClick }) {
  return (
    <footer className="relative border-t border-border">
      {/* Contact Section */}
      <section id="contact" className="py-20 px-4">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center space-y-8">
            {/* CTA Card */}
            <div className="glass rounded-2xl p-12 max-w-3xl mx-auto">
              <h2 className="text-3xl font-bold mb-4">
                Prêt à migrer vers
                <span className="text-gradient-purple"> Auth0 ?</span>
              </h2>
              <p className="text-lg text-muted-foreground mb-8">
                Lancez notre diagnostic interactif pour obtenir une évaluation personnalisée
                de votre projet de migration en quelques minutes.
              </p>
              <Button
                size="lg"
                onClick={onCTAClick}
                className="bg-primary hover:bg-primary/90 text-primary-foreground glow-purple text-lg px-12 py-6"
              >
                Lancer le Diagnostic Interactif
              </Button>
            </div>

            {/* Contact Info Grid — tous cliquables */}
            <div className="grid md:grid-cols-3 gap-6 pt-8">
              {/* Email */}
              <a
                href={COMPANY.emailHref}
                className="glass rounded-xl p-6 text-center group hover:border-primary/40
                  border border-border/30 transition-all duration-200 hover-lift"
              >
                <Mail className="w-8 h-8 text-primary mx-auto mb-3 group-hover:scale-110 transition-transform" />
                <div className="text-sm text-muted-foreground mb-1">Email</div>
                <div className="font-medium text-foreground group-hover:text-primary transition-colors">
                  {COMPANY.email}
                </div>
                <div className="text-xs text-muted-foreground mt-1">Cliquez pour envoyer un email</div>
              </a>

              {/* Téléphone */}
              <a
                href={COMPANY.phoneHref}
                className="glass rounded-xl p-6 text-center group hover:border-primary/40
                  border border-border/30 transition-all duration-200 hover-lift"
              >
                <Phone className="w-8 h-8 text-primary mx-auto mb-3 group-hover:scale-110 transition-transform" />
                <div className="text-sm text-muted-foreground mb-1">Téléphone</div>
                <div className="font-medium text-foreground group-hover:text-primary transition-colors">
                  {COMPANY.phoneDisplay}
                </div>
                <div className="text-xs text-muted-foreground mt-1">Cliquez pour appeler</div>
              </a>

              {/* Adresse */}
              <a
                href={COMPANY.mapsHref}
                target="_blank"
                rel="noopener noreferrer"
                className="glass rounded-xl p-6 text-center group hover:border-primary/40
                  border border-border/30 transition-all duration-200 hover-lift"
              >
                <MapPin className="w-8 h-8 text-primary mx-auto mb-3 group-hover:scale-110 transition-transform" />
                <div className="text-sm text-muted-foreground mb-1">Adresse</div>
                <div className="font-medium text-foreground group-hover:text-primary transition-colors">
                  {COMPANY.address.street}
                </div>
                <div className="text-sm text-foreground/70">{COMPANY.address.zip} {COMPANY.address.city}</div>
                <div className="text-xs text-muted-foreground mt-1">Ouvrir dans Google Maps</div>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Footer Bottom */}
      <div className="border-t border-border">
        <div className="container mx-auto px-4 py-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
              <Shield className="w-6 h-6 text-primary" />
              <span className="font-bold">
                <span className="text-gradient-purple">Auth0</span>
                <span>.Expert</span>
              </span>
            </Link>

            {/* Legal links */}
            <div className="flex items-center gap-6 text-sm text-muted-foreground">
              <Link to="/mentions-legales" className="hover:text-foreground transition-colors">
                Mentions Légales
              </Link>
              <Link to="/confidentialite" className="hover:text-foreground transition-colors">
                Confidentialité
              </Link>
              <Link to="/cgv" className="hover:text-foreground transition-colors">
                CGV
              </Link>
              <Link to="/contact" className="hover:text-foreground transition-colors">
                Contact
              </Link>
            </div>

            {/* Copyright */}
            <div className="text-sm text-muted-foreground">
              © {new Date().getFullYear()} {COMPANY.legalName}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
